<script>
import "swiper/swiper-bundle.css";
import Swiper, { Scrollbar } from "swiper";
Swiper.use([Scrollbar]);

export default {
  name: "ProductsScroll",
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 1,
      freeMode: true,
      spaceBetween: 20,
      scrollbar: {
        el: ".sections-scrollbar",
        draggable: true,
        dragSize: 80,
      },
      navigation: {
        nextEl: ".sections-next",
        prevEl: ".sections-prev",
      },
      breakpoints: {
        600: {
          slidesPerView: "auto",
        }
      }
    });
  },
};
</script>

<template>
  <div class="block-sections-scroll">
    <div ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-sections-scroll {
  .swiper-container {
    width: 100%;
  }

  .swiper-wrapper {
  }
}
</style>
